import{useEffect as u,useRef as c}from"react";const s=(f,r,e)=>{const t=c(!1);u(()=>{f&&!t.current&&e&&(t.current=!0,e(r))},[r,f,e])};export{s as useOnLoadedSuccessByEffect};
